import React from 'react'
import { useParams } from "react-router";

export default function ParamsToProps(props) {
  const { component: Component } = props;
  const params = useParams();
  return <Component {...params}></Component>
}
